import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getEmbeddedLaborTicket = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.embeddedLaborTicket;
  }
);
